<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div class="template">
    <audio id="audioPlayer1" src="https://cdn.exploreve.fr/content/IM2/audio/Standard niv1 traité.mp3"></audio>
    <audio id="audioPlayer2" src="https://cdn.exploreve.fr/content/IM2/audio/Standard niv2 traité.mp3"></audio>
    <audio id="audioPlayer3" src="https://cdn.exploreve.fr/content/IM2/audio/Standard niv3 traité.mp3"></audio>
    <audio id="audioPlayer4" src="https://cdn.exploreve.fr/content/IM2/audio/Standard niv4 traité.mp3"></audio>
    <audio id="audioPlayer5" src="https://cdn.exploreve.fr/content/IM2/audio/Standard niv5 traité.mp3"></audio>
    <audio id="audioPlayer6" src="https://cdn.exploreve.fr/content/IM2/audio/Standard niv6 traité.mp3"></audio>

    <div ondragstart="return false;" ondrop="return false;" class="wrapper" id="_grid_" draggable="false">
      <div v-for="n in nb_pix" :key="n" draggable="false" @mousedown="down" @mouseup="up" @mouseover="moove">
        <div class="case" :id="n" draggable="false" @mousedown="down" @mouseup="up" @mouseover="moove">
          <div class="pix_color" :id="1000 + n" draggable="false"></div>
        </div>
      </div>
      <div class="prise">
        <img
          class="jack"
          id="jack3"
          src="https://cdn.exploreve.fr/content/colourshift/orange.png"
          alt
          draggable="false"
        />
        <img
          class="jack"
          id="jack2"
          src="https://cdn.exploreve.fr/content/colourshift/blue.png"
          alt
          draggable="false"
        />
        <img
          class="jack"
          id="jack1"
          src="https://cdn.exploreve.fr/content/colourshift/purple.png"
          alt
          draggable="false"
        />
        <img
          class="jack"
          id="jack0"
          src="https://cdn.exploreve.fr/content/colourshift/grey.png"
          alt
          draggable="false"
        />
        <img
          class="jack"
          id="jack4"
          src="https://cdn.exploreve.fr/content/colourshift/green.png"
          alt
          draggable="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import * as Sentry from "@sentry/browser";

export default {
  data() {
    return {
      width: 300,
      height: 300,
      nb_pix: 36,
      source_id: [
        [1, 7, 8, 11],
        [19, 20, 11, 15],
        [6, 14, 25, 31],
        [7, 15, 16, 25],
        [1, 2, 3, 9, 21],
        [2, 8, 10, 16, 21]
      ],
      target_id: [
        [20, 15, 21, 26],
        [36, 25, 35, 26],
        [29, 30, 22, 36],
        [36, 20, 31, 33],
        [13, 26, 36, 32, 31],
        [32, 30, 29, 33, 36]
      ],
      color: ["grey", "purple", "blue", "orange", "green"],
      filled: Array(37).fill(-1),
      source_color: [0, 1, 2, 3, 4],
      on: false,
      current: -1,
      path: [],
      lvl: 0,
      succed: [],
      x_grid: 68,
      y_grid: 9,
      texte: "Niveau suivant"
    };
  },
  mounted() {
    this.load();
  },
  components: {},

  methods: {
    lvl_up() {
      var player = document.getElementById("audioPlayer" + (this.lvl + 1).toString());
      player.play();
      player.addEventListener("ended", () => {
        for (let k = 0; k < this.source_id[this.lvl].length; k++) {
          this.path[k] = [];
          this.succed[k] = false;
          let end = document.getElementById("jack" + k);
          end.style.visibility = "hidden";
          end.classList.remove("c90");
          end.classList.remove("c180");
          end.classList.remove("c270");
        }
        for (let k = 1; k < 37; k++) {
          this.filled[k] = -1;
          this.reset(document.getElementById(1000 + k));
        }
        this.lvl += 1;

        if (this.lvl < this.source_id.length) {
          this.load();
        } else {
          this.$emit("finish");
        }
      });
    },

    load: function () {
      for (let k = 0; k < this.source_id[this.lvl].length; k++) {
        let el = document.getElementById(this.source_id[this.lvl][k]).firstChild;
        el.style.background = this.color[this.source_color[k]];
        el.style.borderRadius = "0px";
        this.filled[this.source_id[this.lvl][k]] = this.source_color[k];
        this.path.push([]);
        this.succed.push(false);
      }
      for (let k = 0; k < this.source_id[this.lvl].length; k++) {
        let el = document.getElementById(this.target_id[this.lvl][k]).firstChild;
        el.style.background = this.color[this.source_color[k]];
        el.style.borderRadius = "15px";
        this.filled[this.source_id[this.lvl][k]] = this.source_color[k];
        this.path.push([]);
        this.succed.push(false);
      }
      for (let k = 0; k < this.source_id[this.lvl].length; k++) {
        let el = document.getElementById(this.target_id[this.lvl][k]).firstChild;
        el.style.background = this.color[this.source_color[k]];
        this.filled[this.target_id[this.lvl][k]] = this.source_color[k];
      }
    },

    id_from_target: function (x, y) {
      let i = Math.floor((x - this.x_grid) / 70);
      let j = Math.floor((y - this.y_grid) / 70);
      return j * 6 + i + 1;
    },

    is_target: function (n) {
      let res = false;
      for (let i = 0; i < this.source_id[this.lvl].length; i++) {
        res = res || this.target_id[this.lvl][i] == n;
      }
      return res;
    },

    is_source: function (n) {
      let res = false;
      for (let i = 0; i < this.source_id[this.lvl].length; i++) {
        res = res || this.source_id[this.lvl][i] == n;
      }
      return res;
    },

    up() {
      this.on = false;
    },

    down(event) {
      var i = event.target.id;
      if (i > 1000) {
        i -= 1000;
      }

      if (this.filled[i] != -1 && !this.is_target(i)) {
        let c = this.filled[i];
        if (this.path[c].length == 0) {
          this.path[c].push(parseInt(i));
        } else {
          try {
            while (this.path[c][this.path[c].length - 1] != i) {
              let parent = document.getElementById(this.path[c][this.path[c].length - 1]);
              if (!parent) continue;
              let el = parent.firstChild;
              if (!el) continue;
              this.reset(el);
              this.filled[this.path[c][this.path[c].length - 1]] = -1;
              this.path[c].pop();
            }
          } catch (e) {
            Sentry.captureException(new Error(e));
          }
        }
        this.current = c;
        this.on = true;
      }
    },

    moove(event) {
      var i = event.target.id;
      if (this.on) {
        if (i > 1000) {
          i -= 1000;
        }

        if (this.is_target(i) && this.filled[i] == this.current) {
          this.close(i);
        }

        if (this.filled[i] == -1 && !this.is_source(i) && !this.is_target(i)) {
          // si la case n'est pas encore coloriée
          this.join(i);
        } else {
          if (this.filled[i] != this.current) {
            if (!this.is_source(i) && !this.is_target(i)) {
              let c = this.filled[i];
              while (this.path[c][this.path[c].length - 1] != i) {
                this.filled[this.path[c][this.path[c].length - 1]] = -1;
                let el = document.getElementById(this.path[c][this.path[c].length - 1]).firstChild;
                this.reset(el);
                this.path[c].pop();
              }
              this.join(i);
            }
          }
        }
      }
    },

    reset: function (el) {
      let i = el.id % 1000;
      let colo = this.filled[i].toString();
      if (colo == -1) {
        colo = this.current;
      }
      this.succed[colo] = false;
      let end = document.getElementById("jack" + colo);
      end.style.visibility = "hidden";
      el.style.background = "white";
      el.style.width = "30px";
      el.style.height = "30px";
      el.style.left = "20px";
      el.style.top = "20px";
    },

    close: function (i) {
      this.succed[this.current] = true;

      this.on = false;

      let end = document.getElementById("jack" + this.current);
      end.style.visibility = "visible";
      let previous = parseInt(this.path[this.current][this.path[this.current].length - 1]);
      let j = parseInt(i);
      let x_jack = (((i - 1) % 6) + 0.5) * 70 + this.x_grid;
      let y_jack = (parseInt((i - 1) / 6) + 0.5) * 70 + this.y_grid;

      if (previous == j - 1) {
        end.classList.add("c90");
        end.style.left = (x_jack - 40).toString() + "px";
        end.style.top = (y_jack - 28).toString() + "px";
      }

      if (previous == j - 6) {
        end.classList.add("c180");
        end.style.left = x_jack - 7 + "px";
        end.style.top = y_jack - 63 + "px";
      }

      if (previous == j + 1) {
        end.classList.add("c270");
        end.style.left = (x_jack + 30).toString() + "px";
        end.style.top = (y_jack - 28).toString() + "px";
      }

      if (previous == j + 6) {
        end.style.left = (x_jack - 5).toString() + "px";
        end.style.top = y_jack + 5 + "px";
      }

      let test_succ = true;
      for (let k = 0; k < this.source_id[this.lvl].length; k++) {
        test_succ = test_succ & this.succed[k];
      }

      if (test_succ) {
        this.lvl_up();
      }
    },

    join: function (i) {
      let el = document.getElementById(i).firstChild;
      this.filled[i] = this.current;

      if (this.path[this.current][this.path[this.current].length - 1] != i) {
        this.path[this.current].push(parseInt(i));
      }

      let previous = parseInt(this.path[this.current][this.path[this.current].length - 2]);
      let j = parseInt(i);
      if (previous == j - 1) {
        el.style.background = this.color[this.current];
        el.style.width = "90px";
        el.style.left = "-45px";
        el.style.height = "20px";
        el.style.top = "25px";
      }

      if (previous == j - 6) {
        el.style.background = this.color[this.current];
        el.style.width = "20px";
        el.style.left = "25px";
        el.style.height = "90px";
        el.style.top = "-45px";
      }

      if (previous == j + 1) {
        el.style.background = this.color[this.current];
        el.style.width = "90px";
        el.style.left = "25px";
        el.style.height = "20px";
        el.style.top = "25px";
      }

      if (previous == j + 6) {
        el.style.background = this.color[this.current];
        el.style.width = "20px";
        el.style.left = "25px";
        el.style.height = "90px";
        el.style.top = "25px";
      }
    }
  }
};
</script>

<style lang="scss">
.prise {
  img {
    height: 60px;
  }
}
.jack {
  position: absolute;
  visibility: hidden;
}

.c90 {
  transform: rotate(90deg);
}

.c180 {
  transform: rotate(180deg);
}

.c270 {
  transform: rotate(270deg);
}

.case {
  height: 70px;
  border: 1px solid black;
}

.wrapper {
  margin: 10px auto;
  display: grid;
  grid-template-columns: repeat(6, 70px);
  grid-template-rows: repeat(6, 70px);
  width: 420px;
  align-content: center;
  background-color: white;
}

.next_lvl {
  margin: 10px auto;
  padding: 10px 30px;
  background: grey;
  color: white;
  border-radius: 4px;
  width: 300px;
}

.next_lvl:hover {
  background: red;
}

.pix_color {
  position: relative;
  left: 20px;
  top: 20px;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  pointer-events: none;
}
</style>
